<template>
  <div>
    <div style="font-size: 18px;font-weight: 700;line-height: 2.2;">訂單計算</div>
    <div style="width: 90%;">
      <el-row style="padding: 4px 8px;background-color: #E5E7EB;font-weight: 300; border: solid 1px #E6E6E6;border-radius: 4px;">
        <el-col :span="17" style="text-align: left;">項目</el-col>
        <el-col :span="2" style="text-align: center;">數量</el-col>
        <el-col :span="5" style="text-align: right;">小計</el-col>
      </el-row>
      <div style="background-color: #FFFFFF;font-weight: 500;border-radius: 4px;">
        <el-row v-for="booking in roomList" style="padding: 8px; border-bottom: solid 1px #E6E6E6;">
          <el-col :span="7" style="text-align: left;">{{ booking.date || '' }} </el-col>
          <el-col :span="10" style="text-align: left;">{{ booking.roomTitle || '' }}</el-col>
          <el-col :span="2" style="text-align: center;">x{{ booking.quantity || '' }}</el-col>
          <el-col :span="5" style="text-align: right;">${{ formatNumber(booking.price) || '' }}</el-col>
        </el-row>
      </div>
      <div style="margin-top: 18px; background-color: #FFFFFF;font-weight: 500;border-radius: 4px;">
        <template v-if="calculateOrder && calculateOrder.priceRuleAdjustment && calculateOrder.priceRuleAdjustment.length > 0">
          <el-row v-for="adjustment in calculateOrder.priceRuleAdjustment" style="padding: 8px; border-bottom: solid 1px #E6E6E6;" :style="{ color: adjustment.price < 0 ? '#ea6a2a' : '' }">
            <el-col :span="7" style="text-align: left;">-</el-col>
            <el-col :span="10" style="text-align: left;">{{ adjustment.title || '' }}</el-col>
            <el-col :span="2" style="text-align: center;">x1</el-col>
            <el-col :span="5" style="text-align: right;"> {{ adjustment.price > 0 ? `$${formatNumber(adjustment.price)}` : formatNumber(adjustment.price) || '' }}</el-col>
          </el-row>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OriginalOrderInfoPartial',
  components: {},
  props: {
    roomList: {
      type: Array,
      default: () => [],
    },
    calculateOrder: {
      type: Object,
      default: () => ({
        price_rule_adjustment: [],
      }),
    },
  },
  data() {
    return {}
  },
  computed: {},
  methods: {
    formatNumber(num) {
      return num.toLocaleString()
    },
  },
}
</script>

<style lang="scss" scoped></style>
